import { Component, OnInit } from '@angular/core';
import { VendorContractorHeadcountService } from './vendor-contractor-headcount-service';
import { VendorService } from '@services/vendor.service';
import { Router } from '@angular/router';
import { Priority } from '@constants/global.enum';
@Component({
  selector: 'app-vendor-contractor-headcount',
  templateUrl: './vendor-contractor-headcount.component.html',
  styleUrls: ['./vendor-contractor-headcount.component.scss'],
})
export class VendorContractorHeadcountComponent implements OnInit {
  month: { label: string; value: string; selected?: boolean }[] = []; 
  totalContractor = 0;
  contractorOnBoarded = 0;
  contractorOffBoarded = 0;
  priority = Priority;
  selectedMonth: { label: string; value: string; selected?: boolean } | null = null;

  get onboardedPct(): number {
    const denom = this.contractorOnBoarded + this.contractorOffBoarded;
    return denom > 0 ? (this.contractorOnBoarded / denom) * 100 : 0;
  }
  get offboardedPct(): number {
    const denom = this.contractorOnBoarded + this.contractorOffBoarded;
    return denom > 0 ? (this.contractorOffBoarded / denom) * 100 : 0;
  }

  constructor(
    private headcountService: VendorContractorHeadcountService,
    private vendorService: VendorService,
    private router: Router
  ) {}

  ngOnInit() {
    this.generateMonths(); 
    this.setDefaultMonth(); 
  }

  generateMonths() {
    const now = new Date();
    for (let i = 0; i <= 12; i++) {
      const month = new Date(now.getFullYear(), now.getMonth() - i, 1);
      const monthLabel = month.toLocaleString('default', { month: 'long', year: 'numeric' });
      this.month.push({ label: monthLabel, value: monthLabel,selected: i===0 });
    }
  }

  setDefaultMonth() {
  const now = new Date();
  const defaultMonth = now.toLocaleString('default', { month: 'long', year: 'numeric' });
  this.selectedMonth = { label: defaultMonth, value: defaultMonth, selected: true };
  this.updateData(this.selectedMonth.value);
}

  valueSelect(event: any): void {
    if (Array.isArray(event) && event.length > 0) {
      this.selectedMonth = event[0];
    } else if (typeof event === 'string') {
      this.selectedMonth = { label: event, value: event };
    } else {
      const now = new Date();
      const fallbackMonth = now.toLocaleString('default', { month: 'long', year: 'numeric' });
      this.selectedMonth = { label: fallbackMonth, value: fallbackMonth, selected: true };
    }
    this.updateData(this.selectedMonth?.value || '');
  }

  updateData(selectedMonth: string): void {
    const fallbackMonth = new Date().toLocaleString('default', { month: 'long', year: 'numeric' });
    const monthToUse = selectedMonth || fallbackMonth;

    this.vendorService.getCurrentVendorName().subscribe({
      next: (vendorName) => {
        if (!vendorName) {
          this.resetContractorData();
          return;
        }
  
        this.headcountService.setVendorName(vendorName);
  
        const contractorData$ = this.headcountService.fetchContractorData(monthToUse);
        if (!contractorData$) {
          this.resetContractorData();
          return;
        }
  
        contractorData$.subscribe({
          next: (response) => this.handleContractorDataResponse(response),
          error: () => this.resetContractorData(),
        });
      },
      error: () => this.resetContractorData(),
    });
  }
  
  private handleContractorDataResponse(response: any): void {
    if (response.data?.length) {
      const { totalContractors, onBoardedContractors, offBoardedContractors } = response.data[0];
      this.totalContractor = totalContractors;
      this.contractorOnBoarded = onBoardedContractors;
      this.contractorOffBoarded = offBoardedContractors;
    } else {
      this.resetContractorData();
    }
  }
  
  private resetContractorData() {
    this.totalContractor = 0;
    this.contractorOnBoarded = 0;
    this.contractorOffBoarded = 0;
  }

  navigateToContractorsList(): void {
    const selectedMonthValue = this.selectedMonth?.value || new Date().toLocaleString('default', { month: 'long', year: 'numeric' });
    const [monthName, year] = selectedMonthValue.split(' ');
    const month = new Date(`${monthName} 1, ${year}`).getMonth() + 1;

    this.router.navigate(['/vendorflow-dashboard/contractors-list'], {
      queryParams: { month, year },
    });
  }
}